<template>
    <app-layout>
      <Head title="Custom Fields"/>
        <template #header>
            <div class="flex justify-between">
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    Custom Fields
                </h2>
                <Link :href="route('custom-fields.create')">
                    <jet-button>Create Custom Field</jet-button>
                </Link>
            </div>
        </template>

        <div class="max-w-7xl mx-auto flex mb-6">
            <div class="w-full p-2 sm:px-6 lg:px-8">
                <div class="bg-white shadow-xl sm:rounded-lg p-4 sm:p-6 lg:p-8 overflow-hidden relative">
                    <general-table
                        :columns="columns"
                        :url="route('custom-fields.table')"
                       
                        selectable
                        :selectActions="selectActions"
                        itemNoun="Custom Field"
                    />
                </div>
            </div>
        </div>

    </app-layout>
</template>

<script>
import CustomFieldTableActionButtons from "@/components/CustomFields/CustomFieldTableActionButtons";
import contactTableActionDelete from "@/components/CustomFields/TableActionDelete";
import { markRaw } from "vue";

export default {
    mounted() {},
    components: {
    },
    props: {
    },
    data() {
        return {
            columns: [
                {
                    label: "Name",
                    name: "name",
                    sortable: true,
                },
                {
                    label: "Type",
                    name: "type",
                    sortable: false,
                    //width: "200px"
                },
                {
                    label: "Contacts using",
                    name: "contact_count",
                    sortable: false,
                    width: "150px"
                },
                {
                    label: "",
                    name: "View",
                    sortable: false,
                    event: "click",
                    width: "150px",
                    component: markRaw(CustomFieldTableActionButtons),
                }
            ],
            selectActions: [
                {
                    label: "Delete",
                    value: "delete",
                    component: markRaw(contactTableActionDelete),
                }
            ],
        };
    },
    computed: {},
    methods: {}
};
</script>
